import { useQuery } from "@tanstack/react-query";
import { getUserContractRequests } from "../api/contracts.api";
import { UserContract } from "../api/contracts.type";

type LoadContractRequestOptions = {
  userId?: string;
  includeAll?: boolean;
  enabled?: boolean;
};

export function useLoadContractRequests(options?: LoadContractRequestOptions) {
  const queryEnabled =
    options?.enabled ?? Boolean(options?.userId || options?.includeAll);
  const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
    queryKey: [
      "contract-requests",
      options?.userId ?? null,
      Boolean(options?.includeAll),
    ],
    queryFn: () => getUserContractRequests(options),
    enabled: queryEnabled,
  });

  return {
    requests: (data || []) as UserContract[],
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
}
